exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action.warn {\n    background-color: red;\n    height: 55px;\n}\n\n.action button,\ninput,\nselect,\ntextarea {\n    font-family: inherit;\n    font-size: inherit;\n    line-height: inherit;\n    float: right;\n    margin-top: -4%;\n}\n\n.action h2 {\n    font-size: 30px;\n    text-align: center;\n    padding-top: 9px;\n    color: white;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/shared/components/invoice-banner/invoice-banner.component.css
// module id = ../../../../../src/app/shared/components/invoice-banner/invoice-banner.component.css
// module chunks = main